//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { AddIcon, Button, Input, Select, Table } from '@gamesb42/ui-kit';

import Status from 'components/common/Status';
import AddModal from './components/AddModal';
import EditModal from './components/EditModal';
import { updateTitle } from 'helpers/common';
import baseRequest from 'queries/baseRequest';

import s from './styles.module.scss';

const columns = [
  {
    title: 'Bank',
    dataIndex: 'bank_name',
    sorter: {
      compare: (a, b) => a.bank_name.localeCompare(b.bank_name),
      multiple: 1,
    },
  },
  {
    title: 'IBAN',
    dataIndex: 'iban_number',
  },
  {
    title: 'Currency',
    dataIndex: 'currency',
  },
  {
    title: 'Client',
    dataIndex: 'company_name',
    sorter: {
      compare: (a, b) => a?.company_name?.localeCompare(b?.company_name),
      multiple: 2,
    },
    render: (_, { company_name }) => {
      return company_name?.length > 0 ? company_name : '-';
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: '160px',
    align: 'center',
    sorter: {
      compare: (a, b) => a?.status?.localeCompare(b?.status),
      multiple: 3,
    },
    render: (_, { status }) => {
      return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '88px' }}>
            <Status status={status.toUpperCase()} style={{ width: '100%' }} />
          </div>
        </div>
      );
    },
  },
];

export default function SubAccountPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [value2, setValue2] = useState();
  const [value3, setValue3] = useState();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [activeRecord, setActiveRecord] = useState({});

  const applyFilters = (source = data, q = searchQuery, bank = value2, status = value3) => {
    let next = source;

    const query = (q || '').trim().toLowerCase();
    if (query) {
      next = next.filter((el) =>
        [el.iban_number, el.company_name, el.bank_name]
          .filter(Boolean)
          .some((field) => String(field).toLowerCase().includes(query)),
      );
    }

    if (bank) {
      next = next.filter((el) => el.bank_name === bank);
    }
    if (status) {
      next = next.filter((el) => el.status === status);
    }

    setFilteredData(next);
  };

  const getData = async () => {
    try {
      const result = await baseRequest({
        path: `${process.env.REACT_APP_SCA_URL}/v1/subaccounts/?only_available=false`,
        options: {
          method: 'GET',
        },
      });

      setData(result);
      applyFilters(result);
    } catch (error) {
      console.error('Ошибка при получении субаккаунтов:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updateTitle('Sub accounts');
    getData();
  }, []);

  return (
    <>
      <div style={{ maxWidth: '934px' }}>
        <div className={s.title}>
          <h1>Sub accounts</h1>
          <Button icon={<AddIcon size={16} />} type="primary" onClick={() => setIsOpenAddModal(true)}>
            Create IBAN
          </Button>
        </div>
        {!loading && (
          <>
            <div className={s.actionBar}>
              <div style={{ width: 470 }}>
                <Input
                  size="middle"
                  label="Search"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => {
                    const q = e.target.value;
                    setSearchQuery(q);
                    applyFilters(data, q);
                  }}
                  allowClear
                />
              </div>
              <Select
                style={{ width: 200 }}
                size="middle"
                label="Bank"
                value={value2}
                onChange={(e) => {
                  const bank = typeof e === 'undefined' ? undefined : e;
                  setValue2(bank);
                  applyFilters(data, searchQuery, bank);
                }}
                allowClear
              >
                <Select.Option value="Unlimint">Unlimint</Select.Option>
                <Select.Option value="Ecomm">Ecomm</Select.Option>
              </Select>
              <Select
                style={{ width: 200 }}
                size="middle"
                label="Status"
                value={value3}
                onChange={(e) => {
                  const status = typeof e === 'undefined' ? undefined : e;
                  setValue3(status);
                  applyFilters(data, searchQuery, value2, status);
                }}
                allowClear={true}
              >
                <Select.Option value="active">
                  <Status status="ACTIVE" style={{ width: '100%' }} />
                </Select.Option>
                <Select.Option value="closed">
                  <Status status="CLOSED" style={{ width: '100%' }} />
                </Select.Option>
              </Select>
            </div>

            <Table
              columns={columns}
              dataSource={filteredData}
              initialHeight="500px"
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    setActiveRecord(record);
                    setIsOpenEditModal(true);
                  },
                };
              }}
            />
          </>
        )}
      </div>
      {isOpenAddModal && (
        <AddModal
          onClose={() => {
            setIsOpenAddModal(false);
          }}
          getData={getData}
        />
      )}
      {isOpenEditModal && (
        <EditModal
          onClose={() => {
            setIsOpenEditModal(false);
          }}
          getData={getData}
          activeRecord={activeRecord}
        />
      )}
    </>
  );
}
